import React from 'react';
import { Skeleton } from 'antd';
import { motion } from 'framer-motion';
import { fadeInVariants } from '../../utils/animations';

const LayoutSkeleton = () => {
  return (
    <motion.div
      variants={fadeInVariants}
      initial="hidden"
      animate="visible"
      exit="hidden"
      transition={{ duration: 0.3 }}
      className="h-screen flex overflow-hidden bg-app-base text-app-primary"
    >
      {/* Sidebar Skeleton */}
      <div className="hidden md:flex md:flex-shrink-0">
        <div className="flex flex-col w-64">
          <div className="flex flex-col h-0 flex-1 border-r border-app-subtle dark:border-white/10 bg-app-surface">
            {/* Logo area */}
            <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
              <div className="flex items-center flex-shrink-0 px-4 mb-5">
                <Skeleton.Avatar active size={36} shape="square" />
              </div>
              
              {/* Navigation items skeleton */}
              <nav className="mt-5 flex-1 px-2 space-y-1">
                {[1, 2, 3, 4, 5, 6, 7].map((item) => (
                  <div key={item} className="px-3 py-2">
                    <Skeleton active paragraph={false} title={{ width: '80%' }} />
                  </div>
                ))}
              </nav>
              
              {/* Download section skeleton */}
              <div className="flex-shrink-0 border-t border-app-subtle dark:border-white/10">
                <div className="p-4 border-b border-app-subtle dark:border-white/10">
                  <Skeleton.Button active size="default" style={{ width: '100%' }} />
                </div>
                
                {/* User profile skeleton */}
                <div className="flex items-center w-full p-4">
                  <div className="flex-1 min-w-0 mr-2">
                    <Skeleton active paragraph={{ rows: 2, width: ['80%', '60%'] }} title={false} />
                  </div>
                  <div className="flex space-x-2 flex-shrink-0">
                    <Skeleton.Avatar active size={32} shape="circle" />
                    <Skeleton.Avatar active size={32} shape="circle" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main content skeleton */}
      <div className="flex flex-col w-0 flex-1 overflow-hidden">
        <main className="flex-1 relative z-0 overflow-y-auto">
          {/* Mobile menu button skeleton */}
          <div className="md:hidden fixed top-4 left-4 z-50">
            <Skeleton.Button active size="default" shape="round" />
          </div>
          
          {/* Content area skeleton */}
          <div
            className="h-full relative overflow-y-auto"
            style={{ padding: '24px' }}
          >
            {/* Page header skeleton */}
            <div className="mb-6">
              <Skeleton active paragraph={false} title={{ width: 300, style: { marginBottom: 8 } }} />
              <Skeleton active paragraph={{ rows: 1, width: 400 }} title={false} />
            </div>

            {/* Cards skeleton */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
              {[1, 2, 3, 4].map((item) => (
                <div key={item} className="bg-app-surface border border-app-subtle rounded-lg p-4">
                  <Skeleton active paragraph={{ rows: 2 }} title={false} />
                </div>
              ))}
            </div>

            {/* Main content card skeleton */}
            <div className="bg-app-surface border border-app-subtle rounded-lg p-6">
              <Skeleton active paragraph={{ rows: 8 }} title={{ width: '60%' }} />
            </div>
          </div>
        </main>
      </div>
    </motion.div>
  );
};

export default LayoutSkeleton;


